import axios from "axios";
import { StatisticsURL } from "../../Services";
import { authenticatedHeader } from "../../DefaultConfig";
import { HideAwaiting, ShowAwaiting } from "../../../util/Awaiting";

export async function getArticleHourlyStats(time: number) {
  ShowAwaiting();
  var res = await axios.get(
    StatisticsURL +
    "api/statistics/article/count/hourly/last-x-days/" +
    String(time)
    , authenticatedHeader()
  );
  HideAwaiting();
  return res.data;
}

export async function getArticleDailyStats(time: number) {
  ShowAwaiting();
  var res = await axios.get(
    StatisticsURL +
    "api/statistics/article/count/daily/last-x-days/" +
    String(time)
    ,
    authenticatedHeader()
  );
  HideAwaiting();
  return res.data;
}
